import { styled } from "@vw-marketing/us-components";


export const StyledModalFormContainer = styled.div`

display: flex;
flex-wrap: wrap;
width: 100%;
height: 100%;
background: #ffffff;
align-items: center;
z-index: 4;
padding: 45px 32px;
position: relative;
`

export const StyledModalFormHeaderContainer = styled.div`
${() => `
    display: flex;
    flex-direction: column;
    row-gap: 36px;
    margin-bottom: 28px;
    .form-close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        button {
            background: #DFE4E8;
            border-radius: 32px;
        }

    }

    .form-back {
        color: #001E50;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: 10px;
        span {
            margin: 0;
        }
    }
`}`;
